<script setup lang="ts">
import SvgIcon from './index.vue';

interface Props {
  suffix?: string;
  size?: number;
}

withDefaults(defineProps<Props>(), {
  size: 14
});
</script>

<template>
  <img v-if="suffix === 'dark'" src="@/assets/images/btnIcons/power-dark.svg" alt="">
  <img v-else-if="suffix === 'disabled'" src="@/assets/images/btnIcons/power-disabled.svg" alt="">
  <img v-else-if="suffix === 'regeneration'" src="@/assets/images/btnIcons/power-regeneration.svg" alt="">
  <img v-else-if="suffix === 'origin'" src="@/assets/images/btnIcons/power-origin.svg" alt="">
  <img v-else-if="suffix === 'download-image'" src="@/assets/images/others/vip-download-image.svg" alt="">
  <SvgIcon v-else directory="btnIcons" name="power" :size="size" />
</template>

<style lang="less" scoped>
img {
  width: 14px;
  height: 14px;
}
</style>